import React from "react";
import "./Home.css"; 
import Cta from "./Cta";

function Contact(props) {
    return (
        <div>
            { /*===== HERO AREA STARTS =======*/ }
<div className="inner-header-section-area" style={{ backgroundImage: "url(assets/img/all-images/bg/BG-Orange-shade.png)", backgroundPosition: "center", backgroundRepeat: "no-repeat", backgroundSize: "cover" }}>
  <img src="assets/img/elements/elements28.webp" alt="" className="elements28" />
  <div className="container">
    <div className="row align-items-center">
      <div className="col-lg-12">
        <div className="hero-header">
          <h1 className="text-anime-style-1">Contact Us</h1>
          <div className="space28" />
          <a href="index.html" className="bradecrumb">Home <i className="fa-solid fa-angle-right" /> Contact Us</a>
        </div>
      </div>
    </div>
  </div>
</div>
{ /*===== HERO AREA ENDS =======*/ }

{ /*===== CONTACT AREA STARTS =======*/ }
<div className="contact-inner-section-area sp2">
    <div className="container">
      <div className="row">
        <div className="col-lg-8 m-auto">
          <div className="heading4 text-center space-margin60">
            <h5 className="vl-section-subtitle">JEEVANDAAN Hospital<span> | </span> Caring for Your Community <svg xmlns="http://www.w3.org/2000/svg" width="13" height="8" viewBox="0 0 13 8" fill="none">
              <path d="M0.667969 4.00033H11.049M8.00137 7.33366L11.3346 4.00033L8.0013 0.666992" stroke="#02015A" strokeWidth={1.5} />
            </svg>
          </h5>
          <div className="space24" />
          <h2 className="vl-section-title text-anime-style-3">Connect With Our 3 Branch</h2>
          </div>
        </div>
      </div>
      <div className="row">
      {/*   <div className="col-lg-4 col-md-6">
            <div className="conatct-widget-boxarea">
                <h5>New York, USA</h5>
                <div className="textarea">
                    <div className="icons">
                        <svg xmlns="http://www.w3.org/2000/svg" width="24" height="24" viewBox="0 0 24 24" fill="none">
                            <path d="M14.05 6C15.0268 6.19057 15.9244 6.66826 16.6281 7.37194C17.3318 8.07561 17.8095 8.97326 18 9.95M14.05 2C16.0793 2.22544 17.9716 3.13417 19.4163 4.57701C20.8609 6.01984 21.7721 7.91101 22 9.94M18.5 21C9.93959 21 3 14.0604 3 5.5C3 5.11378 3.01413 4.73086 3.04189 4.35173C3.07375 3.91662 3.08968 3.69907 3.2037 3.50103C3.29814 3.33701 3.4655 3.18146 3.63598 3.09925C3.84181 3 4.08188 3 4.56201 3H7.37932C7.78308 3 7.98496 3 8.15802 3.06645C8.31089 3.12515 8.44701 3.22049 8.55442 3.3441C8.67601 3.48403 8.745 3.67376 8.88299 4.05321L10.0491 7.26005C10.2096 7.70153 10.2899 7.92227 10.2763 8.1317C10.2643 8.31637 10.2012 8.49408 10.0942 8.64506C9.97286 8.81628 9.77145 8.93713 9.36863 9.17882L8 10C9.2019 12.6489 11.3501 14.7999 14 16L14.8212 14.6314C15.0629 14.2285 15.1837 14.0271 15.3549 13.9058C15.5059 13.7988 15.6836 13.7357 15.8683 13.7237C16.0777 13.7101 16.2985 13.7904 16.74 13.9509L19.9468 15.117C20.3262 15.255 20.516 15.324 20.6559 15.4456C20.7795 15.553 20.8749 15.6891 20.9335 15.842C21 16.015 21 16.2169 21 16.6207V19.438C21 19.9181 21 20.1582 20.9007 20.364C20.8185 20.5345 20.663 20.7019 20.499 20.7963C20.3009 20.9103 20.0834 20.9262 19.6483 20.9581C19.2691 20.9859 18.8862 21 18.5 21Z" stroke="#31353D" strokeWidth={1.6} strokeLinecap="round" strokeLinejoin="round" />
                          </svg>
                    </div>
                    <div className="text">
                        <a href="tel:+202-9393-939399">+202-9393-9393 99</a>
                    </div>
                </div>

                <div className="textarea">
                    <div className="icons">
                        <svg xmlns="http://www.w3.org/2000/svg" width="24" height="24" viewBox="0 0 24 24" fill="none">
                            <path d="M12 21C15.5 17.4 19 14.1764 19 10.2C19 6.22355 15.866 3 12 3C8.13401 3 5 6.22355 5 10.2C5 14.1764 8.5 17.4 12 21Z" stroke="#31353D" strokeWidth={1.6} strokeLinecap="round" strokeLinejoin="round" />
                            <path d="M12 13C13.6569 13 15 11.6569 15 10C15 8.34315 13.6569 7 12 7C10.3431 7 9 8.34315 9 10C9 11.6569 10.3431 13 12 13Z" stroke="#31353D" strokeWidth={1.6} strokeLinecap="round" strokeLinejoin="round" />
                          </svg>
                    </div>
                    <div className="text">
                        <a href="tel:+202-9393-939399">USA Address - 254 Chapman Rd, Ste 208 #13379 Katche, Melaware 19702</a>
                    </div>
                </div>

                <div className="textarea">
                    <div className="icons">
                        <svg xmlns="http://www.w3.org/2000/svg" width="24" height="24" viewBox="0 0 24 24" fill="none">
                            <path d="M4 18L9 12M20 18L15 12M3 8L10.225 12.8166C10.8665 13.2443 11.1872 13.4582 11.5339 13.5412C11.8403 13.6147 12.1597 13.6147 12.4661 13.5412C12.8128 13.4582 13.1335 13.2443 13.775 12.8166L21 8M6.2 19H17.8C18.9201 19 19.4802 19 19.908 18.782C20.2843 18.5903 20.5903 18.2843 20.782 17.908C21 17.4802 21 16.9201 21 15.8V8.2C21 7.0799 21 6.51984 20.782 6.09202C20.5903 5.71569 20.2843 5.40973 19.908 5.21799C19.4802 5 18.9201 5 17.8 5H6.2C5.0799 5 4.51984 5 4.09202 5.21799C3.71569 5.40973 3.40973 5.71569 3.21799 6.09202C3 6.51984 3 7.07989 3 8.2V15.8C3 16.9201 3 17.4802 3.21799 17.908C3.40973 18.2843 3.71569 18.5903 4.09202 18.782C4.51984 19 5.07989 19 6.2 19Z" stroke="#31353D" strokeWidth={1.6} strokeLinecap="round" strokeLinejoin="round" />
                          </svg>
                    </div>
                    <div className="text">
                        <a href="mailto:infologistic@example.com">infologistic@example.com</a>
                    </div>
                </div>
            </div>
        </div>

        <div className="col-lg-4 col-md-6">
            <div className="conatct-widget-boxarea">
                <h5>Dallas Texas, USA</h5>
                <div className="textarea">
                    <div className="icons">
                        <svg xmlns="http://www.w3.org/2000/svg" width="24" height="24" viewBox="0 0 24 24" fill="none">
                            <path d="M14.05 6C15.0268 6.19057 15.9244 6.66826 16.6281 7.37194C17.3318 8.07561 17.8095 8.97326 18 9.95M14.05 2C16.0793 2.22544 17.9716 3.13417 19.4163 4.57701C20.8609 6.01984 21.7721 7.91101 22 9.94M18.5 21C9.93959 21 3 14.0604 3 5.5C3 5.11378 3.01413 4.73086 3.04189 4.35173C3.07375 3.91662 3.08968 3.69907 3.2037 3.50103C3.29814 3.33701 3.4655 3.18146 3.63598 3.09925C3.84181 3 4.08188 3 4.56201 3H7.37932C7.78308 3 7.98496 3 8.15802 3.06645C8.31089 3.12515 8.44701 3.22049 8.55442 3.3441C8.67601 3.48403 8.745 3.67376 8.88299 4.05321L10.0491 7.26005C10.2096 7.70153 10.2899 7.92227 10.2763 8.1317C10.2643 8.31637 10.2012 8.49408 10.0942 8.64506C9.97286 8.81628 9.77145 8.93713 9.36863 9.17882L8 10C9.2019 12.6489 11.3501 14.7999 14 16L14.8212 14.6314C15.0629 14.2285 15.1837 14.0271 15.3549 13.9058C15.5059 13.7988 15.6836 13.7357 15.8683 13.7237C16.0777 13.7101 16.2985 13.7904 16.74 13.9509L19.9468 15.117C20.3262 15.255 20.516 15.324 20.6559 15.4456C20.7795 15.553 20.8749 15.6891 20.9335 15.842C21 16.015 21 16.2169 21 16.6207V19.438C21 19.9181 21 20.1582 20.9007 20.364C20.8185 20.5345 20.663 20.7019 20.499 20.7963C20.3009 20.9103 20.0834 20.9262 19.6483 20.9581C19.2691 20.9859 18.8862 21 18.5 21Z" stroke="#31353D" strokeWidth={1.6} strokeLinecap="round" strokeLinejoin="round" />
                          </svg>
                    </div>
                    <div className="text">
                        <a href="tel:+202-9393-939399">+202-9393-9393 99</a>
                    </div>
                </div>

                <div className="textarea">
                    <div className="icons">
                        <svg xmlns="http://www.w3.org/2000/svg" width="24" height="24" viewBox="0 0 24 24" fill="none">
                            <path d="M12 21C15.5 17.4 19 14.1764 19 10.2C19 6.22355 15.866 3 12 3C8.13401 3 5 6.22355 5 10.2C5 14.1764 8.5 17.4 12 21Z" stroke="#31353D" strokeWidth={1.6} strokeLinecap="round" strokeLinejoin="round" />
                            <path d="M12 13C13.6569 13 15 11.6569 15 10C15 8.34315 13.6569 7 12 7C10.3431 7 9 8.34315 9 10C9 11.6569 10.3431 13 12 13Z" stroke="#31353D" strokeWidth={1.6} strokeLinecap="round" strokeLinejoin="round" />
                          </svg>
                    </div>
                    <div className="text">
                        <a href="tel:+202-9393-939399">USA Address - 254 Chapman Rd, Ste 208 #13379 Katche, Melaware 19702</a>
                    </div>
                </div>

                <div className="textarea">
                    <div className="icons">
                        <svg xmlns="http://www.w3.org/2000/svg" width="24" height="24" viewBox="0 0 24 24" fill="none">
                            <path d="M4 18L9 12M20 18L15 12M3 8L10.225 12.8166C10.8665 13.2443 11.1872 13.4582 11.5339 13.5412C11.8403 13.6147 12.1597 13.6147 12.4661 13.5412C12.8128 13.4582 13.1335 13.2443 13.775 12.8166L21 8M6.2 19H17.8C18.9201 19 19.4802 19 19.908 18.782C20.2843 18.5903 20.5903 18.2843 20.782 17.908C21 17.4802 21 16.9201 21 15.8V8.2C21 7.0799 21 6.51984 20.782 6.09202C20.5903 5.71569 20.2843 5.40973 19.908 5.21799C19.4802 5 18.9201 5 17.8 5H6.2C5.0799 5 4.51984 5 4.09202 5.21799C3.71569 5.40973 3.40973 5.71569 3.21799 6.09202C3 6.51984 3 7.07989 3 8.2V15.8C3 16.9201 3 17.4802 3.21799 17.908C3.40973 18.2843 3.71569 18.5903 4.09202 18.782C4.51984 19 5.07989 19 6.2 19Z" stroke="#31353D" strokeWidth={1.6} strokeLinecap="round" strokeLinejoin="round" />
                          </svg>
                    </div>
                    <div className="text">
                        <a href="mailto:infologistic@example.com">infologistic@example.com</a>
                    </div>
                </div>
            </div>
        </div>

        <div className="col-lg-4 col-md-6">
            <div className="conatct-widget-boxarea">
                <h5>California, USA</h5>
                <div className="textarea">
                    <div className="icons">
                        <svg xmlns="http://www.w3.org/2000/svg" width="24" height="24" viewBox="0 0 24 24" fill="none">
                            <path d="M14.05 6C15.0268 6.19057 15.9244 6.66826 16.6281 7.37194C17.3318 8.07561 17.8095 8.97326 18 9.95M14.05 2C16.0793 2.22544 17.9716 3.13417 19.4163 4.57701C20.8609 6.01984 21.7721 7.91101 22 9.94M18.5 21C9.93959 21 3 14.0604 3 5.5C3 5.11378 3.01413 4.73086 3.04189 4.35173C3.07375 3.91662 3.08968 3.69907 3.2037 3.50103C3.29814 3.33701 3.4655 3.18146 3.63598 3.09925C3.84181 3 4.08188 3 4.56201 3H7.37932C7.78308 3 7.98496 3 8.15802 3.06645C8.31089 3.12515 8.44701 3.22049 8.55442 3.3441C8.67601 3.48403 8.745 3.67376 8.88299 4.05321L10.0491 7.26005C10.2096 7.70153 10.2899 7.92227 10.2763 8.1317C10.2643 8.31637 10.2012 8.49408 10.0942 8.64506C9.97286 8.81628 9.77145 8.93713 9.36863 9.17882L8 10C9.2019 12.6489 11.3501 14.7999 14 16L14.8212 14.6314C15.0629 14.2285 15.1837 14.0271 15.3549 13.9058C15.5059 13.7988 15.6836 13.7357 15.8683 13.7237C16.0777 13.7101 16.2985 13.7904 16.74 13.9509L19.9468 15.117C20.3262 15.255 20.516 15.324 20.6559 15.4456C20.7795 15.553 20.8749 15.6891 20.9335 15.842C21 16.015 21 16.2169 21 16.6207V19.438C21 19.9181 21 20.1582 20.9007 20.364C20.8185 20.5345 20.663 20.7019 20.499 20.7963C20.3009 20.9103 20.0834 20.9262 19.6483 20.9581C19.2691 20.9859 18.8862 21 18.5 21Z" stroke="#31353D" strokeWidth={1.6} strokeLinecap="round" strokeLinejoin="round" />
                          </svg>
                    </div>
                    <div className="text">
                        <a href="tel:+202-9393-939399">+202-9393-9393 99</a>
                    </div>
                </div>

                <div className="textarea">
                    <div className="icons">
                        <svg xmlns="http://www.w3.org/2000/svg" width="24" height="24" viewBox="0 0 24 24" fill="none">
                            <path d="M12 21C15.5 17.4 19 14.1764 19 10.2C19 6.22355 15.866 3 12 3C8.13401 3 5 6.22355 5 10.2C5 14.1764 8.5 17.4 12 21Z" stroke="#31353D" strokeWidth={1.6} strokeLinecap="round" strokeLinejoin="round" />
                            <path d="M12 13C13.6569 13 15 11.6569 15 10C15 8.34315 13.6569 7 12 7C10.3431 7 9 8.34315 9 10C9 11.6569 10.3431 13 12 13Z" stroke="#31353D" strokeWidth={1.6} strokeLinecap="round" strokeLinejoin="round" />
                          </svg>
                    </div>
                    <div className="text">
                        <a href="tel:+202-9393-939399">USA Address - 254 Chapman Rd, Ste 208 #13379 Katche, Melaware 19702</a>
                    </div>
                </div>

                <div className="textarea">
                    <div className="icons">
                        <svg xmlns="http://www.w3.org/2000/svg" width="24" height="24" viewBox="0 0 24 24" fill="none">
                            <path d="M4 18L9 12M20 18L15 12M3 8L10.225 12.8166C10.8665 13.2443 11.1872 13.4582 11.5339 13.5412C11.8403 13.6147 12.1597 13.6147 12.4661 13.5412C12.8128 13.4582 13.1335 13.2443 13.775 12.8166L21 8M6.2 19H17.8C18.9201 19 19.4802 19 19.908 18.782C20.2843 18.5903 20.5903 18.2843 20.782 17.908C21 17.4802 21 16.9201 21 15.8V8.2C21 7.0799 21 6.51984 20.782 6.09202C20.5903 5.71569 20.2843 5.40973 19.908 5.21799C19.4802 5 18.9201 5 17.8 5H6.2C5.0799 5 4.51984 5 4.09202 5.21799C3.71569 5.40973 3.40973 5.71569 3.21799 6.09202C3 6.51984 3 7.07989 3 8.2V15.8C3 16.9201 3 17.4802 3.21799 17.908C3.40973 18.2843 3.71569 18.5903 4.09202 18.782C4.51984 19 5.07989 19 6.2 19Z" stroke="#31353D" strokeWidth={1.6} strokeLinecap="round" strokeLinejoin="round" />
                          </svg>
                    </div>
                    <div className="text">
                        <a href="mailto:infologistic@example.com">infologistic@example.com</a>
                    </div>
                </div>
            </div>
        </div> */}
        <div className="col-lg-12">
            <div className="contact-single-boxarea2">
              <div className="row">
                <div className="col-lg-4 col-md-6">
                  <div className="single-box">
                    <div className="icons">
                      <svg xmlns="http://www.w3.org/2000/svg" width="33" height="32" viewBox="0 0 33 32" fill="none">
                        <path d="M16.305 29.3327C23.6688 29.3327 29.6383 23.3631 29.6383 15.9993C29.6383 8.63555 23.6688 2.66602 16.305 2.66602C8.94122 2.66602 2.97168 8.63555 2.97168 15.9993C2.97168 23.3631 8.94122 29.3327 16.305 29.3327Z" stroke="#1C293F" strokeWidth={2.5} />
                        <path d="M16.9351 9.15785C16.9351 8.51839 16.4167 8 15.7772 8C15.1378 8 14.6194 8.51839 14.6194 9.15785H16.9351ZM18.9116 18.3738C18.4594 17.9217 17.7264 17.9217 17.2743 18.3738C16.8221 18.826 16.8221 19.559 17.2743 20.0112L18.9116 18.3738ZM19.59 22.3269C20.0421 22.7791 20.7751 22.7791 21.2273 22.3269C21.6795 21.8747 21.6795 21.1417 21.2273 20.6895L19.59 22.3269ZM14.6194 9.15785V14.5611H16.9351V9.15785H14.6194ZM17.2743 20.0112L19.59 22.3269L21.2273 20.6895L18.9116 18.3738L17.2743 20.0112ZM16.9351 16.8768C16.9351 17.5163 16.4167 18.0347 15.7772 18.0347V20.3504C17.6956 20.3504 19.2508 18.7951 19.2508 16.8768H16.9351ZM15.7772 18.0347C15.1378 18.0347 14.6194 17.5163 14.6194 16.8768H12.3037C12.3037 18.7951 13.8589 20.3504 15.7772 20.3504V18.0347ZM14.6194 16.8768C14.6194 16.2374 15.1378 15.719 15.7772 15.719V13.4033C13.8589 13.4033 12.3037 14.9585 12.3037 16.8768H14.6194ZM15.7772 15.719C16.4167 15.719 16.9351 16.2374 16.9351 16.8768H19.2508C19.2508 14.9585 17.6956 13.4033 15.7772 13.4033V15.719Z" fill="#1C293F" />
                      </svg>
                    </div>
                    <div className="text">
                      <h4>Schedule</h4>
                      {/* <div className="space14" /> */}
                      <a href="#">Sun–Fri | 9:00 AM – 6:00 PM</a>
                    </div>
                  </div>
                </div>
    
                <div className="col-lg-4 col-md-6">
                  <div className="single-box">
                    <div className="icons">
                      <svg xmlns="http://www.w3.org/2000/svg" width="33" height="32" viewBox="0 0 33 32" fill="none">
                        <path d="M16.3031 28C20.9697 23.2 25.6364 18.9019 25.6364 13.6C25.6364 8.29807 21.4577 4 16.3031 4C11.1484 4 6.96973 8.29807 6.96973 13.6C6.96973 18.9019 11.6364 23.2 16.3031 28Z" stroke="#1C293F" strokeWidth={2.2} strokeLinecap="round" strokeLinejoin="round" />
                        <path d="M16.3037 17.332C18.5129 17.332 20.3037 15.5412 20.3037 13.332C20.3037 11.1229 18.5129 9.33203 16.3037 9.33203C14.0945 9.33203 12.3037 11.1229 12.3037 13.332C12.3037 15.5412 14.0945 17.332 16.3037 17.332Z" stroke="#1C293F" strokeWidth={2.2} strokeLinecap="round" strokeLinejoin="round" />
                      </svg>
                    </div>
                    <div className="text">
                      <h4>locations</h4>
                    {/*   <div className="space14" /> */}
                      <a href="#">Bhopal, Madhya Pradesh</a>
                    </div>
                  </div>
                </div>
    
                <div className="col-lg-4 col-md-6">
                  <div className="single-box">
                    <div className="icons">
                      <svg xmlns="http://www.w3.org/2000/svg" width="33" height="32" viewBox="0 0 33 32" fill="none">
                        <path d="M6.13704 24.0013L12.8037 16.0013M27.4704 24.0013L20.8037 16.0013M4.80371 10.668L14.437 17.0901C15.2924 17.6604 15.72 17.9456 16.1822 18.0562C16.5908 18.1542 17.0166 18.1542 17.4252 18.0562C17.8874 17.9456 18.315 17.6604 19.1704 17.0901L28.8037 10.668M9.07038 25.3346H24.537C26.0305 25.3346 26.7773 25.3346 27.3477 25.044C27.8494 24.7884 28.2574 24.3804 28.513 23.8786C28.8037 23.3082 28.8037 22.5614 28.8037 21.068V10.9346C28.8037 9.44117 28.8037 8.69442 28.513 8.124C28.2574 7.62222 27.8494 7.21428 27.3477 6.95862C26.7773 6.66797 26.0305 6.66797 24.537 6.66797H9.07038C7.57691 6.66797 6.83016 6.66797 6.25974 6.95862C5.75796 7.21428 5.35002 7.62222 5.09436 8.124C4.80371 8.69442 4.80371 9.44116 4.80371 10.9346V21.068C4.80371 22.5614 4.80371 23.3082 5.09436 23.8786C5.35002 24.3804 5.75796 24.7884 6.25974 25.044C6.83016 25.3346 7.5769 25.3346 9.07038 25.3346Z" stroke="#1C293F" strokeWidth={2} strokeLinecap="round" strokeLinejoin="round" />
                      </svg>
                    </div>
                    <div className="text">
                      <h4>Our Email</h4>
                      {/* <div className="space14" /> */}
                      <a href="jeevandanhospital.hr@gmail.com">jeevandanhospital.hr@gmail.com</a>
                    </div>
                  </div>
                </div>
              </div>
            </div>
          </div>
          <div className="space60" />

        <div className="col-lg-6">
          <div className="images image-anime reveal">
            <img src="assets/img/all-images/contact/contact-img3.webp" alt="" />
          </div>
        </div>
        <div className="col-lg-6" data-aos="zoom-in-up" data-aos-duration="1000">
            <div className="contact-boxarea">
              <h4>book An Appointment</h4>
              <div className="space20" />
              <p>Fill in your details to schedule a consultation with our medical experts and receive quality healthcare support at the right time.</p>
              <div className="space6" />
              <div className="row">
                <div className="col-lg-6">
                  <div className="input-area">
                    <input type="text" placeholder="Full Name*" />
                  </div>
                </div>
    
                <div className="col-lg-6">
                  <div className="input-area">
                    <input type="number" placeholder="Phone Number*" />
                  </div>
                </div>
    
                <div className="col-lg-6">
                  <div className="input-area">
                    <input type="email" placeholder="Email Address*" />
                  </div>
                </div>
    
                <div className="col-lg-6">
                  <div className="input-area">
                    <select name="country" id="country" className="country-area nice-select">
                      <option value="1" data-display="Service Type">Service Type</option>
                      <option value={true}> General Medical Services</option>
                      <option value={true}> Specialist Services</option>
                      <option value={true}> Women’s Health Services</option>
                      <option value={true}> Mental Health and Wellness</option>
                      <option value={true}> Diagnostic and Laboratory Services</option>
                    </select>
                  </div>
                </div>
    
                <div className="col-lg-6">
                  <div className="input-area">
                    <select name="country" id="country1" className="country-area nice-select">
                      <option value="1" data-display="Select Doctor*">Select Doctor*</option>
                      <option value={true}> Dr. Emily Carter - Cardiologist</option>
                      <option value={true}> Dr. Michael - Orthopedic Surgeon</option>
                      <option value={true}> Dr. Olivia - Dermatologist</option>
                      <option value={true}> Dr. Ethan Brown - Pediatrician</option>
                      <option value={true}> Dr. Ava Davis - Neurologist</option>
                    </select>
                  </div>
                </div>
    
                <div className="col-lg-6">
                  <div className="input-area">
                    <input type="date" />
                  </div>
                </div>
    
                <div className="col-lg-12">
                  <div className="input-area">
                    <textarea placeholder="Your Message" />
                  </div>
                </div>
    
                <div className="col-lg-12">
                  <div className="space10" />
                  <div className="input-area">
                    <button type="submit" className="vl-btn4">Complete Your Appointment Now <span><svg xmlns="http://www.w3.org/2000/svg" width="22" height="22" viewBox="0 0 22 22" fill="none">
                      <path fillRule="evenodd" clipRule="evenodd" d="M11 0.25C5.06294 0.25 0.25 5.06294 0.25 11C0.25 16.9371 5.06294 21.75 11 21.75C16.9371 21.75 21.75 16.9371 21.75 11C21.75 5.06294 16.9371 0.25 11 0.25ZM10 7C9.5955 7 9.2309 7.24364 9.0761 7.61732C8.92134 7.99099 9.0069 8.42111 9.2929 8.70711L10.5858 10L7.29289 13.2929C6.90237 13.6834 6.90237 14.3166 7.29289 14.7071C7.68342 15.0976 8.31658 15.0976 8.70711 14.7071L12 11.4142L13.2929 12.7071C13.5789 12.9931 14.009 13.0787 14.3827 12.9239C14.7564 12.7691 15 12.4045 15 12V8C15 7.44772 14.5523 7 14 7H10Z" fill="white" />
                    </svg></span></button>
                  </div>
                </div>
              </div>
            </div>
          </div>
      </div>
    </div>
  </div>
  { /*===== CONTACT AREA ENDS =======*/ }
{ /*===== CTA AREA STARTS =======*/ }
<Cta/>
{ /*===== CTA AREA ENDS =======*/ }
  
  
        </div>
    );
}

export default Contact;